(() => {
  const rootSelector = '[data-size-request]';

  const openDialog = (root) => {
    const dialog = root.querySelector('[data-size-request-dialog]');
    const trigger = root.querySelector('[data-size-request-open]');

    if (!dialog || !trigger) return;

    dialog.hidden = false;
    dialog.setAttribute('aria-hidden', 'false');
    trigger.setAttribute('aria-expanded', 'true');

    window.setTimeout(() => {
      const focusTarget = dialog.querySelector('select, input, button, [tabindex="0"]');
      if (focusTarget) focusTarget.focus();
    }, 0);
  };

  const closeDialog = (root) => {
    const dialog = root.querySelector('[data-size-request-dialog]');
    const trigger = root.querySelector('[data-size-request-open]');

    if (!dialog || !trigger) return;

    dialog.hidden = true;
    dialog.setAttribute('aria-hidden', 'true');
    trigger.setAttribute('aria-expanded', 'false');
    trigger.focus();
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-size-request-open]');
    if (trigger) {
      openDialog(trigger.closest(rootSelector));
      return;
    }

    const closeButton = event.target.closest('[data-size-request-close]');
    if (closeButton) {
      closeDialog(closeButton.closest(rootSelector));
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    document.querySelectorAll(rootSelector).forEach((root) => {
      const dialog = root.querySelector('[data-size-request-dialog]');
      if (dialog && !dialog.hidden) closeDialog(root);
    });
  });

  const initialise = () => {
    document.querySelectorAll(rootSelector).forEach((root) => {
      if (root.querySelector('.libaas-size-request__status')) openDialog(root);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialise, { once: true });
  } else {
    initialise();
  }
})();